/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import PaymentIcon from "@mui/icons-material/Payment";
import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import CancelModal from "../../../components/Modals/Cancel";
import PaymentConfirmationModal from "../../../components/Modals/PaymentConfirmation";
import Table from "../../../components/table/Table";
import {
  closeModal,
  setPagination,
} from "../../../features/company/companySlice";
import { closeModal as closePaymentModal } from "../../../features/payment/paymentSlice";
import UsePlans from "../../../hooks/UsePlans";
import HomeLayout from "../../../layouts/Home";

const Plans = () => {
  const {
    data,
    pagination,
    loading,
    dropdownMenu,
    modal,
    checkedList,
    setCheckedList,
    handleBulkPayment,
    singlePaymentData,
    bulkPaymentData,
    singlePaystackConfig,
    bulkPaystackConfig,
    handleSinglePaymentConfirm,
    handleBulkPaymentConfirm,
    cancelPlanPayload,
    dispatch,
    routes,
    handleSuccess,
    paymentModal,
  } = UsePlans();

  return (
    <HomeLayout {...{ title: "Plans" }}>
      <Box className="flex justify-end gap-4 sm:flex-col mt-3 xl:flex-row flex-col">
        {checkedList.length > 0 && (
          <Button
            className="w-[200px] bg-[var(--c-primary-1)] text-[600] text-[16px] rounded-xl shadow-none normal-case"
            size="medium"
            variant="contained"
            startIcon={<PaymentIcon />}
            onClick={handleBulkPayment}
            sx={{
              bgcolor: "var(--c-primary-1) !important",
              "&:hover": { bgcolor: "var(--c-primary-1) !important" },
            }}
          >
            Pay for {checkedList.length} Plan{checkedList.length > 1 ? "s" : ""}
          </Button>
        )}
        <LoadingButton
          LinkComponent={Link}
          className="w-[167px] bg-[var(--c-primary-0)] mr-8 text-[600] text-[18px] rounded-xl shadow-none normal-case"
          size="medium"
          type="submit"
          variant="contained"
          fullWidth
          startIcon={<AddIcon />}
          to={routes.companies.plans.new}
        >
          Add Plan
        </LoadingButton>
      </Box>
      <div className="w-full  mt-5">
        <Box
          className="pt-8 px-8 pb-2 rounded-lg bg-[var(--c-bg-color)] w-100%"
          sx={{ p: 0 }}
        >
          <Table
            {...{
              checkData: {
                checkedList,
                setCheckedList,
              },
              dropdownMenu,
              data,
              pagination,
              setPagination: (data) => dispatch(setPagination(data())),
              isLoading: loading,
            }}
          />
        </Box>
      </div>
      <CancelModal
        {...{
          open: modal.delete,
          loading: modal.loading,
          title: "Remove Plan",
          subtitle: `Are you sure you want to remove ${cancelPlanPayload?.name}?`,
          btnTexts: ["No", "Yes"],
          handleSuccess,
          handleClose: (_) => dispatch(closeModal("delete")),
        }}
      />

      {/* Single Payment Confirmation Modal */}
      <PaymentConfirmationModal
        open={paymentModal.confirmation}
        loading={paymentModal.loading}
        handleSuccess={handleSinglePaymentConfirm}
        handleClose={() => dispatch(closePaymentModal("confirmation"))}
        paymentData={singlePaymentData}
        paystackConfig={singlePaystackConfig}
        isBulk={false}
      />

      {/* Bulk Payment Confirmation Modal */}
      <PaymentConfirmationModal
        open={paymentModal.bulkConfirmation}
        loading={paymentModal.loading}
        handleSuccess={handleBulkPaymentConfirm}
        handleClose={() => dispatch(closePaymentModal("bulkConfirmation"))}
        paymentData={bulkPaymentData}
        paystackConfig={bulkPaystackConfig}
        isBulk={true}
      />
    </HomeLayout>
  );
};

export default Plans;
